// extracted by mini-css-extract-plugin
export default {"mobile-menu":"Sidebar_mobile-menu__MM9cK","show-menu":"Sidebar_show-menu__FyUfs","menu":"Sidebar_menu__8w7PF","lines":"Sidebar_lines__71twj","text":"Sidebar_text__PdsJ5"};